export interface ClientConfig {
  SERVER_URL: string;
  USERNAME: string;
  /** Google Identity Services client id. Optional on purpose: without it the
   *  sign-in overlay offers guest play only, the game itself still works. */
  GOOGLE_CLIENT_ID: string | undefined;
}

export function loadConfig(): ClientConfig {
  const serverUrl: string | undefined = import.meta.env.VITE_SERVER_URL;
  if (serverUrl === undefined || serverUrl === "") {
    throw new Error(
      "VITE_SERVER_URL is not set. Create client/.env.local with VITE_SERVER_URL=wss://<host>:<port>"
    );
  }
  const googleClientId: string | undefined = import.meta.env.VITE_GOOGLE_CLIENT_ID;
  const username: string = `guest-${Math.floor(Math.random() * 10000)}`;
  return {
    SERVER_URL: serverUrl,
    USERNAME: username,
    GOOGLE_CLIENT_ID: googleClientId === "" ? undefined : googleClientId,
  };
}
